import { render, staticRenderFns } from "./StaticWidgetInfo.vue?vue&type=template&id=68179308"
import script from "./StaticWidgetInfo.vue?vue&type=script&lang=js"
export * from "./StaticWidgetInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports